import React from "react";

export default function LogsKpis({ styles, stats, minutes, limit }) {
  return (
    <div style={styles.grid}>
      <div style={styles.card}>
        <div style={styles.kpiRow}>
          <div style={styles.kpiLabel}>Geladene Einträge</div>
          <div style={styles.kpiValue}>{stats.total}</div>
        </div>
        <div style={{ marginTop: 6, fontSize: 12, opacity: 0.75 }}>
          Letzte {minutes} Min. · höchstens {limit}
        </div>
      </div>

      <div style={styles.card}>
        <div style={styles.kpiRow}>
          <div style={styles.kpiLabel}>Fehler</div>
          <div style={{ ...styles.kpiValue, color: "#dc2626" }}>{stats.errors}</div>
        </div>
        <div style={{ marginTop: 6, fontSize: 12, opacity: 0.75 }}>FATAL und ERROR in dieser Ansicht</div>
      </div>

      <div style={styles.card}>
        <div style={styles.kpiRow}>
          <div style={styles.kpiLabel}>Warnungen</div>
          <div style={{ ...styles.kpiValue, color: "#b45309" }}>{stats.warns}</div>
        </div>
        <div style={{ marginTop: 6, fontSize: 12, opacity: 0.75 }}>WARN in dieser Ansicht</div>
      </div>
    </div>
  );
}
